export default "__VITE_ASSET__C4Ur10Vc__"